import * as React from "react"
import type { SVGProps } from "react"
const SvgLetterSpacing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m6 22-4-4 4-4 1.425 1.4-1.6 1.6h12.35L16.6 15.4 18 14l4 4-4 4-1.425-1.4 1.6-1.6H5.825L7.4 20.6zm.9-9L11 2h2l4.1 11h-1.9l-.95-2.8H9.8l-1 2.8zm3.45-4.4h3.3l-1.6-4.55h-.1z" />
  </svg>
)
export default SvgLetterSpacing
